<template>
  <div id="app" class="app-container">
    <router-view></router-view>
    <footer>
      <lang-selector></lang-selector>
      <footer-bar></footer-bar>
    </footer>
  </div>
</template>

<script>
  import { ResizeSensor } from 'css-element-queries';
  import { mapGetters, mapActions } from 'vuex';
  import FooterBar from './components/footer/footer-bar.vue';
  import LangSelector from './components/footer/lang-selector.vue';

  export default {
    data () {
      return {
        id: null
      };
    },

    components: { FooterBar, LangSelector },

    computed: {
      ...mapGetters([
        'active_module'
      ]),
    },
    methods: {
      ...mapActions([
        'init_url'
      ]),

      setPostMessageListener () {
        if (window.top !== window.self) {
          window.addEventListener('message', function (event) {
            // console.log('set url', event.data);
            this.$store.commit('SET_IFRAME_ID', event.data.id);

            this.init_url({
              module_id: this.$route.params.module_id,
              url: event.origin,
              affiliate: event.data.aid
            });

            // console.log('event', event.data);
            // console.log(event.origin);
          }.bind(this), false);
        }
      },

      setResizeSensor () {
        if (window.top !== window.self) {
          let element = document.getElementById('app');
            /* eslint-disable no-new */
          new ResizeSensor(element, () => {
            if (window.parent.postMessage) {
              window.parent.postMessage({
                id: this.$store.state.Module.iframe_id,
                type: 'resize',
                height: element.clientHeight
              }, '*');
            }
          });
        }
      }
    },

    created () {
      this.setPostMessageListener();
    },

    mounted () {
      this.setResizeSensor();
    }
  };
</script>

<style>
  html, body {
    height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }

  body {
    background-color: transparent;
  }

 .app-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  /* main {
    flex: 1;
  } */

  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// App.vue?86bc368a